export const MFE_CUSTOM_JS_SCRIPT_ID = 'mfe-custom-js';

export function injectCustomScript(url, scriptId = MFE_CUSTOM_JS_SCRIPT_ID) {
  const resolvedScriptId = scriptId || MFE_CUSTOM_JS_SCRIPT_ID;
  const existingScript = document.getElementById(resolvedScriptId);

  if (!url) {
    existingScript?.remove();
    return null;
  }

  if (existingScript?.getAttribute('src') === url) {
    return existingScript;
  }

  existingScript?.remove();

  const script = document.createElement('script');
  script.id = resolvedScriptId;
  script.src = url;
  script.async = false;

  document.body.appendChild(script);

  return script;
}
